import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  CheckDuplicateEntityShippingPolicyItemCodeQuery,
  EntityLocationShippingFeesApi,
} from 'api';
import { entityLocationShippingFeeQuery } from 'containers/Branding/Farm/Setting/commons/query';

export const createEntityLocationShippingFeeMulti = createAsyncThunk(
  'entityLocationShippingFee/createEntityLocationShippingFeeMulti',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await EntityLocationShippingFeesApi.createMulti(body);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const checkDuplicateEntityShippingPolicyItemCode = createAsyncThunk(
  'entityLocationShippingFee/checkDuplicateEntityShippingPolicyItemCode',
  async (
    query: CheckDuplicateEntityShippingPolicyItemCodeQuery,
    { rejectWithValue }
  ) => {
    try {
      const response = await EntityLocationShippingFeesApi.checkDuplicate(
        query
      );

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const filterEntityLocationShippingFee = createAsyncThunk(
  'entityLocationShippingFee/filterEntityLocationShippingFee',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await EntityLocationShippingFeesApi.filter(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface Update {
  id: string;
  body: any;
}
export const updateEntityLocationShippingFee = createAsyncThunk(
  'entityLocationShippingFee/updateEntityLocationShippingFee',
  async (params: Update, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await EntityLocationShippingFeesApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const removeEntityLocationShippingFee = createAsyncThunk(
  'entityLocationShippingFee/removeEntityLocationShippingFee',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await EntityLocationShippingFeesApi.remove(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface State {
  tableList: Array<any>;
  orderList: Array<any>;
  list: Array<any>;
  reloadFlag: boolean;
  query: any;
}

const initialState: State = {
  tableList: [],
  orderList: [],
  list: [],
  reloadFlag: false,
  query: entityLocationShippingFeeQuery,
};

const entityLocationShippingFeeSlice = createSlice({
  name: 'entityLocationShippingFeeSlice',
  initialState,
  reducers: {
    reloadEntityLocationShippingFee(state) {
      state.reloadFlag = !state.reloadFlag;
    },
  },
  extraReducers: {},
});

const { actions, reducer: entityLocationShippingFeeReducer } =
  entityLocationShippingFeeSlice;

export const { reloadEntityLocationShippingFee } = actions;

export default entityLocationShippingFeeReducer;
